module.exports = __webpack_public_path__ + "static/img/spring_banner.b3cb1aa9.jpg";